import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HiDownload, HiMail, HiGlobe } from 'react-icons/hi';
import { Helmet } from 'react-helmet';
import resumeDoc from '../Balaji_Iyer_Resume.docx';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Person",
            "name": "Balaji Iyer",
            "jobTitle": "Full Stack Developer",
            "url": "https://balajiiyer29.com",
            "sameAs": [
              "https://au.linkedin.com/in/balaji-iyer-2904"
            ],
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Brisbane",
              "addressCountry": "Australia"
            }
          })}
        </script>
      </Helmet>
      <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-200' 
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Stylish Logo/Brand */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex items-center space-x-3 cursor-pointer group"
            onClick={scrollToTop}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-lg">B</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold gradient-text">
                Balaji Iyer
              </h1>
              <p className="text-xs text-neutral-500 font-medium">Full Stack Developer</p>
            </div>
          </motion.div>

          {/* Action Buttons */}
          <div className="flex items-center space-x-4">
            {/* Download CV Button */}
            <a
              href={resumeDoc}
              download="Balaji_Iyer_Resume.docx"
              className="hidden sm:flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-success-500 to-success-600 text-white rounded-xl text-sm font-medium shadow-lg hover:shadow-xl transition-all duration-200"
            >
              <HiDownload size={16} />
              <span>Download CV</span>
            </a>

            {/* Contact Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-accent-500 to-accent-600 text-white rounded-xl text-sm font-medium shadow-lg hover:shadow-xl transition-all duration-200"
            >
              <HiMail size={16} />
              <span className="hidden sm:inline">Contact</span>
            </motion.button>

            {/* Portfolio Link */}
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#"
              className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-warning-500 to-warning-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
              title="Portfolio"
            >
              <HiGlobe size={18} />
            </motion.a>
          </div>
        </div>
      </div>
    </motion.header>
    </>
  );
};

export default Header; 